<template>
    <a class="btn btn-white"
       data-analytics-id="Sync"
       @click.prevent="click">
        <i class="fa-solid fa-arrows-rotate fa-fw"></i>
        {{ l('NAV.SYNC') }}
    </a>
</template>

<script>
import { container } from '@/container';

export default {
    emits: [
        'done',
    ],

    methods: {
        async click() {
            if (!container.connectivityChecker.isOnline()) {
                container.toastFactory.error('SYNC.OFFLINE_ERROR');
                return;
            }

            container.toastFactory.spinner('SYNC.STARTING');
            await container.syncedDataManager.clearData();

            setTimeout(() => {
                window.location.reload();
            }, 100);

            this.$emit('done');
        },
    },
};
</script>
